import { Box } from "@mui/material";
import AccountComponent from "../../components/account/account";
function AccountPage() {
  return <Box>{<AccountComponent />}</Box>;
}

export default AccountPage;
